import { render, staticRenderFns } from "./time-zone.vue?vue&type=template&id=b282e546&scoped=true&"
import script from "./time-zone.vue?vue&type=script&lang=tsx&"
export * from "./time-zone.vue?vue&type=script&lang=tsx&"
import style0 from "./time-zone.vue?vue&type=style&index=0&id=b282e546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b282e546",
  null
  
)

export default component.exports